import { WSAlertProps } from "@wingspanhq/fe-component-library";

export const alertMissingDataProps: WSAlertProps = {
  theme: "warning",
  icon: "alert",
  title: "Missing information"
};
